import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconTowCapBraked: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="tow-cap-braked">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.25 2.9A3.85 3.85 0 0 0 8.4 6.75V8c0 1.23.853 2.26 2 2.53v1.37H10a1.6 1.6 0 0 0-1.6 1.6v.158a1.4 1.4 0 0 1-.442-.488L6.095 9.755A2.6 2.6 0 0 0 3.813 8.4H3v1.2h.813a1.4 1.4 0 0 1 1.229.73l1.863 3.415A2.6 2.6 0 0 0 9.187 15.1H19.25a.65.65 0 1 1 0 1.3H7a1.4 1.4 0 0 1-1.12-.56l-.3-.4A2.6 2.6 0 0 0 3.5 14.4H3v1.2h.5a1.4 1.4 0 0 1 1.12.56l.3.4A2.6 2.6 0 0 0 7 17.6h2.4V19a1.6 1.6 0 0 0 1.6 1.6h3a1.6 1.6 0 0 0 1.6-1.6v-1.4h3.65a1.85 1.85 0 1 0 0-3.7H16.6v-.4a1.6 1.6 0 0 0-1.6-1.6h-.4v-1.37c1.147-.27 2-1.3 2-2.53V6.75a3.85 3.85 0 0 0-3.85-3.85zM9.6 6.75a2.65 2.65 0 0 1 2.65-2.65h.5a2.65 2.65 0 0 1 2.65 2.65V8A1.4 1.4 0 0 1 14 9.4h-3A1.4 1.4 0 0 1 9.6 8zm3.8 5.15v-1.3h-1.8v1.3zm2 2H9.6v-.4a.4.4 0 0 1 .4-.4h5c.22 0 .4.18.4.4zm-4.8 3.7h3.8V19a.4.4 0 0 1-.4.4h-3a.4.4 0 0 1-.4-.4z"
    />
  </Icon>
);
